module.exports = __webpack_public_path__ + "static/img/yinliangjian2.e6b303c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/yinliangjian2.png
// module id = thKZ
// module chunks = 24